"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BreakpointsNumeric;
(function (BreakpointsNumeric) {
    BreakpointsNumeric[BreakpointsNumeric["xxsmall"] = 376] = "xxsmall";
    BreakpointsNumeric[BreakpointsNumeric["xsmall"] = 650] = "xsmall";
    BreakpointsNumeric[BreakpointsNumeric["small"] = 767.98] = "small";
    BreakpointsNumeric[BreakpointsNumeric["medium"] = 1025] = "medium";
    BreakpointsNumeric[BreakpointsNumeric["large"] = 1199.98] = "large";
    BreakpointsNumeric[BreakpointsNumeric["xlarge"] = 1700] = "xlarge";
    BreakpointsNumeric[BreakpointsNumeric["xxlarge"] = 2300] = "xxlarge";
})(BreakpointsNumeric || (BreakpointsNumeric = {}));
exports.default = BreakpointsNumeric;
//# sourceMappingURL=breakpointsnumeric.js.map